import React, { useState } from 'react';
import AdSpacesAdminList from './components/AdSpacesAdminList';
import AdSpacesAdminAddAdSpacePage from './components/adSpacesAdminAddAdSpacePage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpacesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List adSpaces" />
        <Tab label="Insert adSpace" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpacesAdminList />}
        {tab === 1 && <AdSpacesAdminAddAdSpacePage />}
      </Box>
    </Box>
  );
};

export default AdSpacesAdminPage;